<script setup lang="ts">
import { ChipComponent } from '@metapic-apps/shared'
import { ref, toRef, watch } from 'vue'

import { useGetAdvertiserListRequest } from '@/api'
import type { AdvertiserListItemType } from '@/lib/types/advertiser.types'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import { FlexComponent, SelectComponent } from '@/ui-library'

const props = defineProps<{
  advertiserGroup: number
  isEditMode: boolean
}>()
const advertiserList = defineModel<CampaignFormType['advertiserList']>('modelValue', { default: [] })
const emit = defineEmits(['update:modelValue'])

const advertiserGroup = toRef(() => props.advertiserGroup)
const advertisersQuery = ref('')
const { data: advertiserOptions, isLoading: isAdvertisersLoading } = useGetAdvertiserListRequest(advertiserGroup, advertisersQuery)

const onSearch = (str: string) => (advertisersQuery.value = str)
const handleClose = (advertiserItem: AdvertiserListItemType) =>
  emit(
    'update:modelValue',
    advertiserList.value.filter((item) => item.id !== advertiserItem.id),
  )

watch(
  () => advertiserGroup.value,
  () => (advertisersQuery.value = ''),
)
</script>
<template>
  <el-form-item prop="advertiserList">
    <div>
      <SelectComponent
        v-model="advertiserList"
        :is-loading="isAdvertisersLoading"
        :options="advertiserOptions"
        :remote-method="onSearch"
        title="Advertiser"
        placeholder="Search advertiser"
        value-key="id"
        multiple
        remote
        filterable
        name="advertiserList"
        :disabled="isEditMode"
        :extra-class="advertiserList.length ? 'campaign-form-advertiser-selector--wrapper' : ''"
      >
        <template #label>
          <div />
        </template>
      </SelectComponent>
      <FlexComponent v-if="advertiserList.length > 0" wrap="wrap" :gap="8" class="campaign-form-advertiser-selector--container">
        <ChipComponent v-for="item in advertiserList" :key="item.id" :closable="!isEditMode" @close="handleClose(item)">
          {{ item.label }}
        </ChipComponent>
      </FlexComponent>
    </div>
  </el-form-item>
</template>
<style lang="scss" scoped>
:deep(.campaign-form-advertiser-selector--wrapper) {
  .el-select__wrapper {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .el-select__selection.is-near {
      padding: 7px 0;
      margin-left: 0;
    }
  }
}
:deep(.el-select__selected-item:not(.el-select__input-wrapper):not(.is-transparent)) {
  display: none;
}

.campaign-form-advertiser-selector--container {
  padding: 8px;
  border-radius: 0 0 8px 8px;
  background: var(--inverted);
  margin-top: -1px;
  box-shadow: 0 0 0 1px var(--secondary-12) inset;
}
</style>
